import { render, staticRenderFns } from "./ConfigInfo.vue?vue&type=template&id=1b5ac07d&scoped=true&"
import script from "./ConfigInfo.vue?vue&type=script&lang=js&"
export * from "./ConfigInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInfo.vue?vue&type=style&index=0&id=1b5ac07d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ac07d",
  null
  
)

export default component.exports